import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const isLocationUpdated = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/StakeholderLocation/IsLocationUpdated`,
  method: 'get'
});

export const UpdateLocation = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/StakeholderLocation/UpdateLocation`,
  method: 'put',
  data
});

